/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig, withQuery } from './lais/httpHelpers';

class LeadReferralsAPI extends ApiClient {
  constructor() {
    super('lead_referrals', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  show(id) {
    return axios.get(resourcePath(this.url, id), requestConfig());
  }

  create(payload = {}) {
    return axios.post(this.url, { lead_referral: payload }, requestConfig());
  }

  decide(id, payload = {}) {
    return axios.post(
      `${resourcePath(this.url, id)}/decision`,
      { lead_referral: payload },
      requestConfig()
    );
  }

  enableServiceLink() {
    return axios.post(
      `${this.baseUrl()}/agents/service-link/enable`,
      {},
      requestConfig()
    );
  }
}

export default new LeadReferralsAPI();
